export default __webpack_public_path__ + "static/media/review_stars.dd9ab932.svg";